import React, { memo } from "react";
import {
  ApiCategory,
  ApiTag,
} from "../../../../../core/configs/configs.entity";
import { strings } from "../../../../../intl/fa";
import { AdPanelDropdown } from "../../../../commons/dropdown/AdPanelDropdown";

interface Props {
  onCategoryChange: (tag: ApiTag) => void;
  onSubcategoryChange: (tag: ApiCategory) => void;
  categories: ApiTag[];
  subcategories: ApiCategory[] | null;
}

const TagsDropdownFC: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <AdPanelDropdown<ApiTag>
        items={props.categories}
        label={strings.dialog_ad_form.more_settings_step.tags.main}
        onSelectedItemChange={props.onCategoryChange}
        itemToString={(i) => i?.Title ?? ""}
        placeholderMessage={
          strings.dialog_ad_form.more_settings_step.tags.select
        }
        selectedItemFormatter={(category: ApiCategory) => category.Title}
        helpText={strings.dialog_ad_form.more_settings_step.tags.description}
        scrollToWhenClicked
        openOnTop
      />

      {props.subcategories && (
        <AdPanelDropdown<ApiCategory>
          items={props.subcategories}
          label={strings.dialog_ad_form.more_settings_step.tags.sub}
          onSelectedItemChange={props.onSubcategoryChange}
          itemToString={(i) => i?.Title ?? ""}
          placeholderMessage={
            strings.dialog_ad_form.more_settings_step.tags.select
          }
          selectedItemFormatter={(category: ApiCategory) => category.Title}
          helpText={strings.dialog_ad_form.more_settings_step.tags.description}
          scrollToWhenClicked
          openOnTop
          key={JSON.stringify(props.subcategories)}
        />
      )}
    </div>
  );
};

export const TagsDropdown = memo(TagsDropdownFC);
